import Bar from '../../../../components/elements/Bar';
import { Pencil } from 'lucide-react';
import List from '../../../../components/elements/List';
import { usePermission } from '../../../../hooks/usePermission';
import ApprovalItemActions from '../../../approval/components/ApprovalItemActions';

const ProfessionBondView = ({ data, onEdit }) => {
  const { isEditable } = usePermission();
  const prepareData = () => {
    if (!data) return [];
    return [
      { name: 'Název', value: data.title },
      { name: 'Popis', value: data.description },
      { name: 'Profese', value: data.profession?.title },
    ];
  };

  return (
    <div>
      <Bar
        text="Detail"
        content={
          isEditable
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  onClick={onEdit}
                  data-testid="profession-bond-view-edit-btn"
                />,
              ]
            : []
        }
      />
      <ApprovalItemActions objectType="professionbond" objectId={data?.id} status={data?.status} />
      <List data={prepareData()} />
    </div>
  );
};

export default ProfessionBondView;
